<template>
    <div>
        <el-form ref="form"
                 :model="form"
                 label-width="120px"
                 @submit.prevent.native="onSubmit">
            <el-row :gutter="30">
                <el-col :span="19">
                    <div class="box">
                        <div class="box__header">
                            <span class="box__header--text">{{ getRouteName($route) }}</span>
                            <form-language-switcher></form-language-switcher>
                        </div>
                        <el-form-item label="Nazwa"
                                      :error="errors[addLanguageSuffix('name')]"
                                      required>
                            <el-input v-model="form[addLanguageSuffix('name')]">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="Opis"
                                      :error="errors[addLanguageSuffix('description')]">
                            <wyswig-input v-model="form[addLanguageSuffix('description')]"/>
                        </el-form-item>
                        <el-form-item label="Data rozpoczęcia"
                                      :error="errors.start_date">
                            <el-date-picker type="date"
                                            format="yyyy/MM/dd"
                                            value-format="yyyy-MM-dd"
                                            placeholder="Data rozpoczecia sprzedaży"
                                            v-model="form.start_date"/>
                        </el-form-item>
                        <el-form-item label="Data zakończenia"
                                      :error="errors.end_date">
                            <el-date-picker type="date"
                                            format="yyyy/MM/dd"
                                            value-format="yyyy-MM-dd"
                                            placeholder="Data rozpoczecia sprzedaży"
                                            v-model="form.end_date"/>
                        </el-form-item>
                        <el-form-item label="Sold out">
                            <el-switch v-model="form.sold_out"/>
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="box">
                        <div class="box__header">
                            {{ $t('manage') }}
                        </div>
                        <el-form-item class="form__buttons" label-width="0">
                            <router-link :to="redirectRoute">
                                <el-button class="fluid form__button">{{ $t('cancel') }}</el-button>
                            </router-link>
                            <el-button @click="onSubmit"
                                       type="primary"
                                       class="fluid form__button"
                                       :loading="loading">
                                {{ $t('submit') }}
                            </el-button>
                        </el-form-item>
                    </div>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>
<script>
    import {Period} from '@/api/';

    export default {
        data () {
            return {
                loading: false,
                redirectRoute: {name: 'Periods List'},
                form: {},
                errors: {},
                service: Period
            }
        },
        mounted () {
            this.fetchData()
        },
        methods: {
            fetchData () {
                if (this.$route.params.id) {
                    this.service.get(this.$route.params.id).then(response => {
                        this.form = response.data
                    })
                }
            },
            onSubmit () {
                this.loading = true;
                const id = this.$route.params.id
                const service = id ? this.service.update(id, this.form) : this.service.save(this.form)
                service
                    .then(this.successHandler)
                    .catch(this.errorHandler)
            }
        }
    }
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// PeriodForm.vue?42e759da